import { render, staticRenderFns } from "./ApplePay.vue?vue&type=template&id=4e671662&scoped=true&"
import script from "./ApplePay.vue?vue&type=script&lang=js&"
export * from "./ApplePay.vue?vue&type=script&lang=js&"
import style0 from "./ApplePay.vue?vue&type=style&index=0&id=4e671662&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e671662",
  null
  
)

export default component.exports